<div class="form">
    <div *ngIf="tasks" formArray="tasks" class="tasks-list">
        <label class="form-title">{{ 'aumico_reports_fcp_edit_checklist' | i18next }} </label>

        <div *ngFor="let taskGroup of tasks.controls; let i = index" [formGroup]="taskGroup" class="task-item">
            <input
                hamInput
                class="checklist-input"
                formControlName="text"
                placeholder="{{ 'aumico_reports_enter_task_placeholder' | i18next }}"
            />

            <span
                hamIconShapes
                icon="assets/hamIcons/minus.svg"
                [variant]="'hamed'"
                [size]="'xs'"
                [type]="'circle'"
                *ngIf="!taskGroup.get('isDone')?.value"
                (click)="removeTask(i)"
            ></span>
        </div>
        <div class="error" *ngIf="tasks.errors?.['duplicateText']">
            {{ 'aumico_annual_report_fcp_checklist_not_allow_duplicate' | i18next }}
        </div>
    </div>

    <ham-button
        class="add-tasks-btn"
        outline="true"
        [size]="'xs'"
        icon="assets/hamIcons/plus-outline.svg"
        (buttonClick)="addTask()"
        >{{ 'aumico_reports_add_more_tasks_button' | i18next }}</ham-button
    >

    <div class="button-group">
        <ham-button outline="true" (buttonClick)="onCancel()">{{
            'aumico_reports_cancel_button' | i18next
        }}</ham-button>
        <ham-button (buttonClick)="onSubmit()" type="submit" [disabled]="tasks.invalid || tasks.length < 1">{{
            'aumico_reports_save_checklist_button' | i18next
        }}</ham-button>
    </div>
</div>
